module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/step02-2569789288a614a08a43022b28fbb4ee.png";